module.exports = __webpack_public_path__ + "img/lus.0eb4e1dd.svg";